import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-vuurwerk',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconVuurwerk {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M2.2 26.52c-.97.19-1.6-.99-.9-1.69l5.98-5.97-5-1.36c-.97-.26-.99-1.62-.03-1.92l4.27-1.32L2.66 7.7c-.48-.81.33-1.77 1.22-1.44l6.55 2.46V4.78c0-.89 1.08-1.34 1.71-.71l3.46 3.46 2.67-2.75c.63-.65 1.72-.2 1.72.7v3.53l-2 2v-3l-2.38 2.55-1.51-1.51-1.52-1.52v4.28l-2.89-1.09-3.54-1.33 2.23 3.79 1.37 2.33-2.58.8-.53.16 1.22.33 3.56.97-2.61 2.6-3.32 3.32 4.42-.88 2.56-.51.13 3.36-2.27 2.27v-3.02l-8.1 1.62ZM32 7.1V7h-.1zm-5.25-2.37.47.46L25.41 7h3.67l2 2h-7.67l-3 3h8.48l-2 2h-8.48l-3 3h8.48l-2 2H17l2.45 2.45-9.85 9.84c-.63.63-.18 1.71.71 1.71h.27a1 1 0 0 0 .71-.3L32.9 10.84l.41.42c.63.64 1.71.19 1.71-.7V4c0-.55-.44-1-.99-1l-6.55.02c-.9 0-1.35 1.08-.71 1.71Z"/>
</svg>

    );
  }
}
